import {
  AjaxCart_default
} from "./chunk--chunk-FU6BXNZB.js";
import "./chunk--chunk-RRQU7OM3.js";
import {
  __async
} from "./chunk--chunk-RQ7252KT.js";

// src/js/components/ImageLazyload.js
var ImageLazyload = class {
  constructor(el, sel) {
    this.el = el;
    if (el.getAttribute(sel) === "intersect") {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.lazyload();
          observer.disconnect();
        }
      });
      observer.observe(el);
    } else {
      const _this = this;
      el.addEventListener(el.getAttribute(sel), function initLazyLoad() {
        _this.lazyload();
        this.removeEventListener(el.getAttribute(sel), initLazyLoad);
      });
    }
  }
  lazyload() {
    this.el.querySelectorAll("img[data-src]").forEach((img) => {
      if (img.parentNode.tagName.toLowerCase() === "video")
        img.parentNode.setAttribute("poster", img.getAttribute("data-src"));
      img.src = img.getAttribute("data-src");
      img.removeAttribute("data-src");
    });
  }
};
var ImageLazyload_default = ImageLazyload;

// src/js/components/FreeShip.js
var FreeShip = class {
  constructor(el, sel) {
    this.el = el;
    this.threshold = parseInt(el.getAttribute(sel));
    this.progress = el.querySelector("[data-progress]");
    this.remaining = el.querySelector("[data-remaining]");
    this.content = el.querySelector("[data-freeship-content]");
    this.achievedContent = el.querySelector("[data-freeship-achieved]");
    this.attachListeners();
  }
  attachListeners() {
    const getPrice = () => __async(this, null, function* () {
      const res = yield fetch("/cart.js");
      const json = yield res.json();
      this.updateElements(json.total_price);
    });
    document.addEventListener("ajaxcart refresh", getPrice);
    getPrice();
  }
  updateElements(cartPrice) {
    const newRemaining = (this.threshold - cartPrice) / 100;
    if (newRemaining > 0) {
      this.content.style.display = "block";
      this.achievedContent.style.display = "none";
      this.remaining.innerHTML = newRemaining.toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
      });
      let percent = 100 - newRemaining * 100 / this.threshold * 100;
      if (percent < 3) {
        percent = 3;
      }
      this.progress.style.width = percent + "%";
    } else {
      this.content.style.display = "none";
      this.achievedContent.style.display = "block";
    }
  }
};
var FreeShip_default = FreeShip;

// src/js/helpers/ComponentConstructor.js
function initComponentOnConnectedComponentLoad(componentToInit, handleToWatch, selectorDispatch, element, dataSelect) {
  document.addEventListener(handleToWatch + " loaded", function handler() {
    const component = new componentToInit(element, dataSelect);
    if (component.init)
      component.init();
    document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
    this.removeEventListener(handleToWatch + " loaded", handler);
  });
}
function initComponentOnConnectedComponentDomEvent(componentToInit, handleToWatch, trigger, selectorDispatch, element, dataSelect) {
  document.querySelectorAll("[data-" + handleToWatch + "]").forEach(
    (elementTrigger) => elementTrigger.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    })
  );
}
function initComponentOnSelfDomEvent(componentToInit, trigger, selectorDispatch, element, dataSelect) {
  if (window.innerWidth < 768 && trigger === "mouseover") {
    initComponentOnSelfIntersection(
      componentToInit,
      selectorDispatch,
      element,
      dataSelect
    );
  } else {
    element.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    });
  }
}
function initComponentOnSelfIntersection(componentToInit, selectorDispatch, element, dataSelect) {
  const component = new componentToInit(element, dataSelect);
  if (component.init) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        component.init();
        document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
        observer.disconnect();
      }
    }, {
      rootMargin: "300px 0px 0px 0px"
    });
    observer.observe(element);
  }
}
function ComponentConstructor(components) {
  Object.entries(components).forEach(([selector, Component]) => {
    const dataSelect = "data-" + selector;
    const matchedElements = document.querySelectorAll("[" + dataSelect + "]");
    matchedElements.forEach((element) => {
      if (Array.isArray(Component)) {
        if (Component.filter((option) => typeof option === "string" && option.includes("url:")).length > 0) {
          const urls = Component.map((option) => typeof option === "string" && option.includes("url:") ? option.split("url:")[1] : false);
          let shouldInit = false;
          for (const url of urls) {
            if (url && window.location.href.includes(url)) {
              shouldInit = true;
            }
          }
          if (shouldInit) {
            initComponentOnSelfIntersection(
              Component[0],
              selector,
              element,
              dataSelect
            );
            return;
          }
        }
        Component.forEach((option, i) => {
          if (i === 0 || option.includes("url:"))
            return;
          if (option.includes(":")) {
            const triggerType = option.split(":")[0];
            const triggerSelector = option.split(":")[1];
            if (triggerType === "load") {
              initComponentOnConnectedComponentLoad(
                Component[0],
                triggerSelector,
                selector,
                element,
                dataSelect
              );
            } else {
              initComponentOnConnectedComponentDomEvent(
                Component[0],
                triggerSelector,
                triggerType,
                selector,
                element,
                dataSelect
              );
            }
          } else {
            initComponentOnSelfDomEvent(
              Component[0],
              option,
              selector,
              element,
              dataSelect
            );
          }
        });
        return;
      }
      initComponentOnSelfIntersection(Component, selector, element, dataSelect);
    });
  });
}

// src/global.js
document.addEventListener(
  "DOMContentLoaded",
  function globalComponents() {
    return __async(this, null, function* () {
      const components = {
        "image-lazyload": ImageLazyload_default,
        "ajax-cart": AjaxCart_default,
        "free-ship": FreeShip_default
      };
      if (document.querySelector("[data-quick-add]")) {
        const QuickAdd = yield import("./chunk--QuickAdd-GCORMZ3C.js");
        components["quick-add"] = [QuickAdd.default, "mouseover"];
      }
      if (document.querySelector("[data-slider]")) {
        const Slider = yield import("./chunk--Slider-L52RSAI6.js");
        components["slider"] = Slider.default;
      }
      if (document.querySelector("[data-product-form]")) {
        const ProductForm = yield import("./chunk--ProductForm-U652IIOP.js");
        components["product-form"] = ProductForm.default;
      }
      ComponentConstructor(components);
      document.dispatchEvent(new CustomEvent("global components loaded"));
      this.removeEventListener("DOMContentLoaded", globalComponents);
    });
  }
);
document.addEventListener(
  "global components loaded",
  function asyncComponents() {
    return __async(this, null, function* () {
      const components = {};
      if (document.querySelector("[data-hc-control]")) {
        const Accordion = yield import("./chunk--Accordion-AK3LXNOY.js");
        components["hc-control"] = Accordion.default;
      }
      if (document.querySelector("[data-back-to-top]")) {
        const BackToTop = yield import("./chunk--BackToTop-WPWA53QG.js");
        components["back-to-top"] = BackToTop.default;
      }
      if (document.querySelector("[data-modals]")) {
        const Modals = yield import("./chunk--Modals-O7KC5DMY.js");
        components["modals"] = Modals.default;
      }
      if (document.querySelector("[data-tabs]")) {
        const Tabs = yield import("./chunk--Tabs-6FEAFVCR.js");
        components["tabs"] = Tabs.default;
      }
      if (document.querySelector("[data-video]")) {
        const Video = yield import("./chunk--Video-LLA7QJXZ.js");
        components["video"] = Video.default;
      }
      if (document.querySelector("[data-theme-addresses]")) {
        const ThemeAddresses = yield import("./chunk--ThemeAddresses-OTDXDGEV.js");
        components["theme-addresses"] = ThemeAddresses.default;
      }
      if (document.querySelector("[data-sticky-cta-target]")) {
        const StickyCTA = yield import("./chunk--StickyCTA-GYAZURWP.js");
        components["sticky-cta"] = StickyCTA.default;
      }
      if (document.querySelector("[data-smooth-scroll]")) {
        const SmoothScroll = yield import("./chunk--SmoothScroll-WP53PE3D.js");
        components["smooth-scroll"] = SmoothScroll.default;
      }
      if (document.querySelector("[data-subscriptions-widget]")) {
        const ShopifySubscriptionsWidget = yield import("./chunk--ShopifySubscriptionsWidget-QVYSZQJG.js");
        components["subscriptions-widget"] = ShopifySubscriptionsWidget.default;
      }
      if (document.querySelector("[data-bundle]")) {
        const Bundle = yield import("./chunk--Bundle-ST63U4UJ.js");
        components["bundle"] = Bundle.default;
      }
      if (document.querySelector("[data-scroll-to]")) {
        const ScrollTo = yield import("./chunk--ScrollTo-2CWQGA4W.js");
        components["scroll-to"] = ScrollTo.default;
      }
      ComponentConstructor(components);
      document.dispatchEvent(new CustomEvent("async components loaded"));
      this.removeEventListener("global components loaded", asyncComponents);
    });
  }
);
document.addEventListener(
  "async components loaded",
  function deferredComponentListeners() {
    return __async(this, null, function* () {
      const components = {};
      if (document.querySelector("[data-search]")) {
        const Search = yield import("./chunk--Search-37J7GXEL.js");
        components["search"] = [Search.default, "mouseover"];
      }
      ComponentConstructor(components);
      this.removeEventListener("deferred component listeners attached", deferredComponentListeners);
    });
  }
);
document.addEventListener(
  "deferred component listeners attached",
  function deferredComponents() {
    return __async(this, null, function* () {
      const components = {};
      if (document.querySelector("[data-ajax-cart]")) {
        const AjaxCart = yield import("./chunk--AjaxCart-ST4GJ35R.js");
        components["ajax-cart"] = [AjaxCart.default, "mouseover", "load:product-form", "url:/pages/start"];
      }
      if (document.querySelector("[data-product-form]")) {
        const ProductForm = yield import("./chunk--ProductForm-U652IIOP.js");
        components["product-form"] = ProductForm.default;
      }
      ComponentConstructor(components);
      this.removeEventListener("deferred component listeners attached", deferredComponents);
    });
  }
);
